import React, {Fragment} from 'react';
import {createUseStyles} from 'react-jss';
import Select from 'react-select';

import {desktopSelectorStyles} from '../../common-styles/selector-style';
import {
  CLOSE_LOCATION, LOCATION_TRANSLATE,
  OPEN_LOCATION,
  SELECT_LOCATION
} from '../../utils/action-types';
import {DEFAULT_LANGUAGE, RU_LANGUAGE, SELECTED_CITY} from '../../utils/constants';
import {setCookie} from '../../utils/cookie';
import {getCityTranslateByKey} from '../../utils/helpers';
import {COLORS} from '../../utils/style-variables';
import {LocationIcon} from '../icons/location-icon';

import {locationSelectorHoc} from './location-selector-hoc';

const useStyles = createUseStyles({
  locationButton: {
    display: 'inline-block',
    position: 'relative',
    padding: '7px 14px 7px 34px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: COLORS.lightGrey60Color,
    borderRadius: 2,
    fontSize: '15px',
    lineHeight: '20px',
    color: COLORS.blackColor,
    outline: 'none',
    transition: 'all .100s ease-in-out',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 160,
    '& >svg': {
      position: 'absolute',
      left: 12,
      top: 10,
      '& path': {
        transition: 'all .100s ease-in-out'
      }
    },
    '&:focus, &:hover': {
      borderColor: COLORS.blue100Color,
      '& >svg path': {
        fill: COLORS.blue100Color
      }
    }
  },
  dropDownWrapper: {
    display: 'inline-block',
    position: 'relative',
    marginRight: 15
  },
  selectOtherCurrency: {
    position: 'absolute',
    width: 280,
    marginTop: 4,
    padding: 8,
    backgroundColor: '#fff',
    borderRadius: 2,
    boxShadow: '0px 2px 6px rgba(36, 36, 36, 0.3)',
    zIndex: 3
  },
  blanket: {
    bottom: 0,
    left: 0,
    top: 0,
    right: 0,
    position: 'fixed',
    zIndex: 1
  }
});

const desktopLocation = ({listData, changeLocation, state: {open_location_select, locationTranslate}}) => {
  const classes = useStyles();
  const selectLocation = value => {
    changeLocation({
      type: SELECT_LOCATION,
      payload: value
    });
    changeLocation({
      type: LOCATION_TRANSLATE,
      payload: getCityTranslateByKey(value.key)
    });

    // setUp cookies for 365 days
    setCookie(SELECTED_CITY, JSON.stringify(value), 24 * 365);
  };

  return (
    <div className={classes.dropDownWrapper}>
      <button
        className={classes.locationButton}
        onClick={() => changeLocation({type: OPEN_LOCATION})}
      >
        <LocationIcon />
        {locationTranslate[DEFAULT_LANGUAGE]?.nominative}
      </button>
      {open_location_select ?
        <Fragment>
          <div className={classes.selectOtherCurrency}>
            {listData.length ?
              <Select
                autoFocus
                components={{DropdownIndicator: null, IndicatorSeparator: null}}
                backspaceRemovesValue={false}
                controlShouldRenderValue={false}
                hideSelectedOptions={false}
                isClearable={false}
                menuIsOpen
                onChange={selectLocation}
                noOptionsMessage={() => 'Не найдено'}
                placeholder='Населенный пункт'
                tabSelectsValue={false}
                styles={desktopSelectorStyles}
                options={listData}
                getOptionLabel={option => option[RU_LANGUAGE]}
                getOptionValue={option => option.key}
              />
              : null}
          </div>
          <div
            className={classes.blanket}
            onClick={() => changeLocation({type: CLOSE_LOCATION})}
          />
        </Fragment>
        : null}
    </div>
  );
};

export default locationSelectorHoc(desktopLocation);
